<astral-field-shell [control]="textControl" [forId]="inputId" [helpText]="helpText" [errorMessage]="errorMessage">
  <div class="translate-text-box">
    <input
      class="translate-text-box__control"
      autocomplete="off"
      [attr.id]="inputId"
      astralFieldAccessibility
      [astralFieldControl]="textControl"
      [astralFieldHelpText]="helpText"
      [astralFieldInputId]="inputId"
      [formControl]="textControl"
      [placeholder]="textControl.caption | translate"
      [required]="textControl.required ? true : null"
      [readonly]="textControl.isReadonly ? true : null"
      [ngClass]="{ locked: textControl.isReadonly }"
      (blur)="onblur()"
      (focus)="onfocus()"
      />

      @if (showTranslate) {
        <astral-translation-action (activate)="translateClicked()"></astral-translation-action>
      }
    </div>
  </astral-field-shell>
